/**
 * API de Usuários e validação de CEP.
 */
import { api } from './client';

export interface UsuarioApi {
  id: string;
  nome: string;
  email: string;
  cpf: string;
  data_nascimento: string | null;
  cep: string | null;
  telefone: string | null;
  perfil: 'paciente' | 'medico' | 'atendente' | 'admin';
  status_acesso: 'ativo' | 'inativo' | 'bloqueado';
}

export interface UsuarioSyncPayload {
  nome: string;
  email: string;
  cpf: string;
  data_nascimento?: string;
  cep?: string;
  telefone?: string;
  perfil?: 'paciente' | 'medico' | 'atendente';
}

export const usuariosApi = {
  /** Sincroniza dados pós-cadastro Firebase com a API. */
  sync: (payload: UsuarioSyncPayload) =>
    api.post<UsuarioApi>('/api/usuarios/sync', payload),

  me: () => api.get<UsuarioApi>('/api/usuarios/me'),
};

export interface ValidacaoCep {
  cep: string;
  valido: boolean;
  eh_df: boolean;
  eh_df_ou_entorno: boolean;
  medicamento_em_casa_disponivel: boolean;
}

export const ecommerceApi = {
  validarCep: (cep: string) =>
    api.post<ValidacaoCep>('/api/ecommerce/validar-cep', { cep }),
};
